
const asyncData = ({ commit }, data) => {
  commit('gotData', data)
}
const asyncScore = ({ commit }, payload) => {
  commit('gotScore', payload)
}
export default {
  asyncData,
  asyncScore
}
